import { appStore } from '../../app/AppStore';
import { selectCurrentlyApplicableContentTypes } from '../../app/selectors/ContentFilterSelectors';
import { selectDisplaySettings } from '../../app/selectors/DisplaySettingsSelectors';
import { selectSpaceInfo } from '../../app/selectors/SpaceInfoSelectors';
import { SpaceInfo, SpaceType, SubspaceName } from '../../app/state/SpaceInfo';
import { Omit } from '../../ts/helpers/TypescriptHelpers';
import { ExplorableItemType } from '../../ts/models/ContentType';
import { DisplayMode } from '../../ts/ServerApi/types/ISessionInfo';
import { BaseTelemetryEvent, ValidTelemetryEvent } from '../../ts/services/TelemetryService';
import { ExplorerEvent } from './TelemetryEvents';

export type ExplorerEventContentType = ExplorableItemType | 'mixed';

export type ExplorerEventInfo =
  {
    space: SpaceType,
    subspace: SubspaceName,
    contentType: ExplorerEventContentType,
    displayMode: DisplayMode
  };

// I'm not sure why we need to '& BaseTelemetryEvent' but it makes the compiler happy
type EventWithoutExplorerEventInfo<T extends ExplorerEvent> = Omit<T, keyof ExplorerEventInfo> & BaseTelemetryEvent;

/**
 * populates the space, subspace and contentType information for telemetry events
 */
export function CreateExplorerEvent<T extends ExplorerEvent>(
  event: ValidTelemetryEvent<EventWithoutExplorerEventInfo<T>>
): ValidTelemetryEvent<T> {

  const appState = appStore.getState();
  const spaceInfo: SpaceInfo = selectSpaceInfo(appState);
  const contentTypes: ReadonlyArray<ExplorableItemType> = selectCurrentlyApplicableContentTypes(appState);
  const displayMode: DisplayMode = selectDisplaySettings(appState).explorerDisplayMode;

  const explorerEvent = {
    space: spaceInfo.spaceType,
    subspace: spaceInfo.subspaceName,
    contentType: contentTypes.length !== 1 ? 'mixed' : contentTypes[0],
    displayMode: displayMode,
    ...(event as object)
  } as ValidTelemetryEvent<T>;

  return explorerEvent;
}
